<script>
  import {Bar} from 'vue-chartjs'

  export default {
    name: "VendasPeriodo",
    extends: Bar,
    props: ['dados','periodo'],

    computed: {
      chartData() {
        return this.dados;
      }
    },

    methods: {
      renderizarGrafico() {
        let labels = this.chartData.map(e => {
          let label = e.dt_venda;
          const meses = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];

          if (this.periodo !== '1') {
            label = meses[label - 1]
          }

          return label;
        });

        let datasets = this.chartData.map(e => {
          return e.valor;
        });

        let data = {
          labels: labels,
          datasets: [{
            label: 'Vendas no período',
            data: datasets,
            backgroundColor: ['#9454F0', '#1cc88a', '#f6c23e', '#2D3356', '#9454F0', '#1cc88a', '#f6c23e', '#2D3356', '#ff3244'],
            hoverBorderColor: "rgba(234, 236, 244, 1)"
          }]
        };

        let options = {
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                display: true
              }
            }],
            yAxes: [{
              ticks: {
                display: false,
                beginAtZero: true
              },
              gridLines: {
                color: "rgb(234, 236, 244)",
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false
              }
            }]
          },
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleMarginBottom: 10,
            titleFontColor: '#6e707e',
            titleFontSize: 14,
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            intersect: false,
            mode: 'index',
            caretPadding: 10,
            callbacks: {
              title: (tooltipItem) => this.setTitle(tooltipItem),
              label: (tooltipItem) => this.setLabel(tooltipItem)
            }
          }
        };

        this.renderChart(data, options)
      },

      setTitle(item) {
        const title = this.periodo === '1' ? "Dia: " : 'Mês: ';
        let label = item[0].label;
        return title + label
      },

      setLabel(item) {
        let value = item.value;

        if (value === undefined || value === false) {
          return value;
        }

        value = parseFloat(value);
        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2
        });

        return 'Total de vendas: ' + formatter.format(value);
      }
    },

    watch: {
      dados() {
        this.$data._chart.destroy();
        this.renderizarGrafico();
      }
    },

    mounted() {
      this.renderizarGrafico();
    },
  }
</script>
